<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div
        menuSystem
        [cerrixTab]="tab"
        class="details"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="audit-universe-detail-page"
    >
        <div class="detail-page-action-bar">
            @if (!readonly) {
                <button class="btn btn-cerrix" data-uiid="save-audit-universe" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">Save object</span>
                </button>
            }

            @if (historicalView) {
                <span class="sub-message">
                    Viewing historical readonly data. Audit object from
                    {{ model.dateUpdated | dateFormat }}
                </span>
            } @else if (model.id > 0) {
                <span class="date-edited">
                    Last save: {{ model.dateUpdated | dateTimeFormat }}
                </span>
            }

            @if (permissions.canChangeDate) {
                <div class="right-area">
                    <date-input
                        [(value)]="dateFilter"
                        [maxDate]="dateFilterMax"
                        (valueChange)="dateChanged()"
                    ></date-input>
                </div>
            }
        </div>

        <div
            class="screens"
            name="Universe Object"
            menuicon="fad fa-planet-ringed"
            menusystemsubmenu
        >
            <div name="Details" menuicon="fas fa-info-circle" menusystemitem>
                <audit-universe-detail-main
                    [permissions]="permissions"
                    [standingData]="standingData"
                    [model]="model"
                    [formGroup]="formGroup"
                    (dateChanged)="dateChangeHandler($event)"
                ></audit-universe-detail-main>
            </div>
            @if (permissions.canViewRelatedData) {
                <div
                    name="Related Data"
                    [attr.menuItemId]="menuItemData"
                    menuicon="fad fa-planet-ringed"
                    menusystemitem
                >
                    <audit-universe-data
                        [organizations]="model.organizations"
                        [businessDimensions]="model.businessDimensions"
                        [frameworkDimensions]="model.frameworkDimensions"
                        [dateFilter]="dateFilter"
                        [manualMode]="true"
                        #moduleDataComp
                    ></audit-universe-data>
                </div>
            }
            @if (model.id > 0) {
                <div name="Links" menuicon="fas fa-link" menusystemsubmenu>
                    @if (permissions.canViewLinkedAudits) {
                        <div
                            name="Audits"
                            [attr.menuItemId]="menuItemAudits"
                            menuicon="fal fa-clipboard-list-check"
                            menusystemitem
                        >
                            <audit-universe-linked-audits
                                #auditsComponent
                                [auditUniverseModel]="model"
                                [parentForm]="formGroup"
                                [disabled]="!permissions.canLinkAudits"
                            >
                            </audit-universe-linked-audits>
                        </div>
                    }
                    @if (permissions.canViewLinkedForms) {
                        <div
                            [attr.menuItemId]="menuItemForms"
                            name="Forms"
                            menuicon="fas fa-file-alt"
                            menusystemitem
                        >
                            <audit-universe-linked-forms
                                #formsComponent
                                [model]="model"
                                [disabled]="!permissions.canLinkForms"
                            ></audit-universe-linked-forms>
                        </div>
                    }
                    @if (permissions.canViewDocuments) {
                        <div
                            name="Documents"
                            [attr.menuItemId]="menuItemDocuments"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            @if (documents) {
                                <document-manager
                                    [(Documents)]="model.Documents"
                                    (DocumentsChange)="checkDocumentsDirty()"
                                    [permissions]="permissions.documentPermissions"
                                    [DocumentTypeTargets]="targetModule"
                                >
                                </document-manager>
                            } @else {
                                <div class="fancy-loader"></div>
                            }
                        </div>
                    }
                </div>
            }
            @if (permissions.canViewHistory) {
                <div
                    name="History"
                    [attr.menuItemId]="menuItemHistory"
                    menuicon="fas fa-history"
                    menusystemitem
                >
                    @if (id) {
                        <app-history-overview
                            [historyDataService]="_ds"
                            [Id]="id"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    }
                </div>
            }
            @if (model.id > 0) {
                <div name="Options" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="Universe Object"
                        [objectName]="model.name"
                        [allowDelete]="permissions.canDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
